import React from 'react';
import ComingSoon from "../components/ComingSoon";

const Achievements = () => {
  return (
    <div>
      <div className="p-5 sm:px-20 bg-slate-100 dark:bg-slate-900 dark:text-white m-5 rounded-3xl">
        <h1 className="text-center underline font-serif text-3xl font-bold text-purple-700">
          Achievements
        </h1>
        <div className="flex justify-center">
          <ComingSoon />
        </div>
      </div>
    </div>
  );
}

export default Achievements
